import { MdArrowBackIos } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';

const BackButton = ({ className = '', backTo = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (backTo) {
      window.location.replace(backTo);
    } else {
      if (
        location.state?.from?.pathname &&
        (location.state?.from?.pathname === '/catalogue' ||
          location.state?.from?.pathname === '/pieces-d-occasion' ||
          location.state?.from?.pathname === '/jantes-d-occasion' ||
          location.state?.from?.pathname === '/pneus-d-occasion' ||
          location.state?.from?.pathname === '/vehicules-d-occasion' ||
          location.state?.from?.pathname === '/vehicules-accidentes' ||
          location.state?.from?.pathname === '/catalogue/pieces' ||
          location.state?.from?.pathname === '/catalogue/jantes' ||
          location.state?.from?.pathname === '/catalogue/pneus' ||
          location.state?.from?.pathname ===
            '/catalogue/vehicules-d-occasion' ||
          location.state?.from?.pathname === '/catalogue/vehicules-accidentes')
      ) {
        navigate(location.state.from);
      } else {
        navigate('/catalogue');
      }
    }
  };

  return (
    <div
      className={`inline-flex gap-x-[6px] items-center py-[10px] px-[16px] bg-gray rounded cursor-pointer ${className}`}
      onClick={handleBack}
    >
      <MdArrowBackIos className="text-[#9EA5A7] text-[12px]" />
      <p className="text-dark transition">Retour au catalogue</p>
    </div>
  );
};

export default BackButton;
